// src/routes/dynamicRoutes.ts

import { RouteObject } from 'react-router-dom';
import React from 'react';

const ComponentPage = React.lazy(() => 
  import('../pages/components').catch(err => {
    console.error('Failed to load components:', err);
    return import('../pages/not-found');
  })
);

const FoundationsPage = React.lazy(() => 
  import('../pages/FoundationsPage').catch(err => {
    console.error('Failed to load foundations:', err);
    return import('../pages/not-found');
  })
);

const IntroductionPage = React.lazy(() => 
  import('../pages/IntroductionPage').catch(err => {
    console.error('Failed to load introduction-menu:', err);
    return import('../pages/not-found');
  })
);

const IconsPage = React.lazy(() => 
  import('../pages/icons').catch(err => {
    console.error('Failed to load icons:', err);
    return import('../pages/not-found');
  })
);

const LandingPage = React.lazy(() => 
  import('../pages/landingpage').catch(err => {
    console.error('Failed to load landingpage:', err);
    return import('../pages/not-found');
  })
);
const Icons = React.lazy(() => import('../versions/v3.0.0/pages/icons-library'));
// const IconsLibrary = React.lazy(() => 
//   import('../versions/v3.0.0/pages/icons-library').catch(err => {
//     console.error('Failed to load landingpage:', err);
//     return import('../pages/not-found');
//   })
// );

const NotFound = React.lazy(() => import('../pages/not-found'));

export const generateDynamicRoutes = (versionId: string): RouteObject[] => {
  return [
    // ✅ Components - with param and without
    {
      path: '/components',
      Component: ComponentPage,
    },
    {
      path: '/components/:componentName',
      Component: ComponentPage,
    },

    // ✅ Foundations - with param and without
    {
      path: '/foundations',
      Component: FoundationsPage,
    },
    {
      path: '/foundations/:foundationName',
      Component: FoundationsPage,
    },

    // ✅ Introductions - with param and without
    {
      path: '/introductions',
      Component: IntroductionPage,
    },
    {
      path: '/introductions/:pageName',
      Component: IntroductionPage,
    },
    {
      path: '/icons',
      Component: versionId === 'v3.0.0'
        ? Icons
        : IconsPage,
    },
  

  
    // Landing
    {
      path: '/designsystem',
      Component: LandingPage,
    },
    {
      path: '/',
      Component: LandingPage,
    },

    // 404
    {
      path: '*',
      Component: NotFound,
    },
  ];
};
